module.exports = __webpack_public_path__ + "img/84-Sapeli - Acajou.jpg";